import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const REPROCESS_ODOO_INVOICE_CLIENT_RESET   = 'REPROCESS_ODOO_INVOICE_CLIENT_RESET';
export const REPROCESS_ODOO_INVOICE_CLIENT_LOADING = 'REPROCESS_ODOO_INVOICE_CLIENT_LOADING';
export const REPROCESS_ODOO_INVOICE_CLIENT_SUCCESS = 'REPROCESS_ODOO_INVOICE_CLIENT_SUCCESS';
export const REPROCESS_ODOO_INVOICE_CLIENT_REJECT  = 'REPROCESS_ODOO_INVOICE_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const reprocessOdooInvoiceClientReset   = () => ({ type: REPROCESS_ODOO_INVOICE_CLIENT_RESET });
export const reprocessOdooInvoiceClientLoading = () => ({ type: REPROCESS_ODOO_INVOICE_CLIENT_LOADING });
export const reprocessOdooInvoiceClientSuccess = (payload) => ({ type: REPROCESS_ODOO_INVOICE_CLIENT_SUCCESS, payload });
export const reprocessOdooInvoiceClientReject  = (payload) => ({ type: REPROCESS_ODOO_INVOICE_CLIENT_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const reprocessOdooInvoiceClientRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.PUT,
        params,
    }, getState);
    return request(`/Invoices/web/UpdateInvoiceReprocessOdoo`, options);
};
